export interface FieldSchema {
  type:
    | "text"
    | "select"
    | "email"
    | "phone"
    | "password"
    | "number"
    | "boolean"
    | "checkbox"
    | "radio"
    | "compare"
    | "autocomplete"
    | "ssn"
    | "nationalIdNumber"
    | "money"
    | "zipcode"
    | "dob"
    | "textarea"
    | "date"
    | "readonly";
  subtype?:
    | "username"
    | "address"
    | "secondApplicantSSN"
    | "secondApplicantDOB"
    | "drawAmount"
    | "initialDrawAmount"
    | "dob";
  name?: string;
  required?: boolean;
  label?: string;
  hideLabel?: boolean;
  hintPosition?: "top" | "bottom";
  placeholder?: string;
  compareType?:
    | "text"
    | "select"
    | "email"
    | "phone"
    | "number"
    | "boolean"
    | "checkbox"
    | "radio"
    | "password"
    | "zipcode"
    | "textarea";
  compareField?: string;
  validate?: (schema: FormField | FieldSchema, value: any, compare: any) => void;
  onBlur?: (schema: FormField | FieldSchema, value: any, compare: any) => void;
  errorMessage?: string;
  autocompleteProperty?: string;
  touched?: boolean;
  valid?: boolean;
  errors?: string[];
  allowZero?: boolean;
  allowDecimals?: boolean;
  autocomplete?: string;
  maxLength?: number;
  default?: number;
  showRequiredIndicator?: boolean;
  productTypeId?: number;
  minimum?: number;
  tooltipLocation?: string;
}

export interface FormField extends FieldSchema {
  valid: boolean;
  touched: boolean;
  errors?: string[];
  tooltipLocation?: string;
}

export interface FormSchema {
  [key: string]: FieldSchema;
}

export interface Form {
  [key: string]: FormField;
}

export interface Option {
  label: string;
  value: any;
}

export enum FormModes {
  view = "view",
  add = "add",
  edit = "edit",
}

export interface FormChange {
  before: string;
  after: string;
  comment: string;
  key: string;
  name: string;
  label?: string;
}

export interface FormPatch {
  op: keyof typeof FormPatchOperations;
  path: string;
  value?: any;
}

export enum FormPatchOperations {
  add = "add",
  replace = "replace",
  remove = "remove",
}

export interface FormChangesResponse {
  comment?: string;
  changes: FormChange[];
  commentPrefix?: string;
  errorMessage: string;
  userDisplayName?: string;
}

export interface CompareKey {
  key: string;
}

export interface KeyRename extends CompareKey {
  rename: string;
}

export interface KeyFormat extends CompareKey {
  format: (arg: any) => string;
}

export interface CompareOptions {
  keysToPick?: string[];
  keysToRename?: KeyRename[];
  keysToFormat?: KeyFormat[];
	keysToSkip?: string[];
  keysToExcludeFromSummaryComment?: string[];
  commentPrefix?: string;
  userDisplayName?: string;
  mode?: string;
	pathPrefix?: string;
	programTypeId?: number;
	productTypeId?: number;
	fieldsToCompare?: string[];
}

export interface FieldError {
	fieldName: string;
	error: boolean;
	errorMessage?: string;
}